import React, { useState, useRef, useEffect } from "react"
import styled, { css } from "styled-components"
import { Link } from "gatsby"
import Parser from "html-react-parser"

import ClickAwayListener from "@material-ui/core/ClickAwayListener"

import ArrowIcon from "../../../static/icons/arrow-dropdown.svg"
import Triangle from "../../../static/Triangle.svg"
import * as theme from "../../theme"

const Dropdown = ({
  children,
  items,
  path,
  icon,
  openBy,
  offset,
  selectedMenu,
  id
}) => {
  const listRef = useRef(null)

  const [openState, setOpenState] = useState(false)

  let listWidth

  useEffect(() => {
    if (selectedMenu === null || selectedMenu === id) {
      return
    } else {
      setOpenState(false)
    }
  }, [selectedMenu])

  useEffect(() => {
    if (!!listRef.current) {
      // Get width of list div
      listWidth = listRef.current.offsetWidth
      // Apply negative margin-left to center the list under the nav item
      listRef.current.style.marginLeft = -(listWidth / 2) + "px"
    }
  })

  useEffect(() => {
    // Whenever 'path' changes, close dropdown menu
    // This is to close the menu if the user presses the back/forward button
    setOpenState(false)
  }, [path])

  const toggleMenu = () => {
    setOpenState(!openState)
  }

  const openMenu = () => {
    if (openBy !== "click") {
      setOpenState(true)
    }
  }

  const closeMenu = () => {
    if (openBy !== "click") {
      setOpenState(false)
    }
  }

  return (
    <Container>
      {!path.includes("/3d/") && (
        <ClickAwayListener onClickAway={() => setOpenState(false)}>
          <>
            {!!openState && <MouseCheck onMouseEnter={() => closeMenu()} />}
            <NavItem
              isOpen={openState}
              onMouseEnter={() => openMenu()}
              onClick={() => {
                toggleMenu()
              }}
            >
              {children}
              {!!icon && <ArrowIcon />}
            </NavItem>
            <List
              ref={listRef}
              isOpen={openState}
              listWidth={listWidth}
              offset={offset}
              onMouseLeave={() => closeMenu()}
            >
              <Triangle />
              {!!items &&
                items.map(item => {
                  return (
                    <ListItem
                      key={item.id}
                      to={item.pathname}
                      onClick={() => setOpenState(false)}
                      activeClassName="selected"
                    >
                      {!!item.title && Parser(item.title)}
                    </ListItem>
                  )
                })}
            </List>
          </>
        </ClickAwayListener>
      )}
    </Container>
  )
}

export default Dropdown

Dropdown.defaultProps = { openBy: "hover", offset: 55, icon: true }

const Container = styled.div`
  position: relative;
`

const MouseCheck = styled.div`
  position: absolute;
  top: -10vh;
  left: -20vw;
  width: 50vw;
  height: 50vw;
  z-index: 11;
`

const NavItem = styled.button`
  position: relative;
  z-index: 12;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 0;
  padding: 15px 25px;
  /* padding-left: 15px; */
  /* padding-right: 15px; */
  /* padding-top: 10px; */
  /* padding-bottom: 10px; */
  background: none;
  &:focus {
    outline: none;
  }
  &:hover {
    svg {
      opacity: 1;
    }
  }
  svg {
    height: 16px;
    width: 16px;
    transition: opacity 200ms ease-in-out;
    margin-left: 8px;
    ${props => (props.isOpen ? "opacity: 1;" : "opacity: 0.5;")}
  }
`
const openAnim = css`
  opacity: 1;
  transform: scale(1) rotateX(0);
`
const closeAnim = css`
  opacity: 0;
  pointer-events: none;
  transform: scale(0.97) rotateX(-20deg);
`
const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 999;
  ${props => (props.isOpen ? openAnim : closeAnim)}
  position: absolute;
  top: ${props => props.offset + "px"};
  left: 50%;
  background: white;
  padding: 20px 0;
  border-radius: 5px;
  transition: opacity 200ms ease-in-out, transform 200ms ease-in-out;
  will-change: transform, opacity;
  transform-origin: 50% 0%;
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.03);
  svg {
    position: absolute;
    top: -10px;
    left: calc(50% - 5px);
    fill: red;
    path {
      fill: red;
    }
  }
  .selected {
    color: ${theme.color.select};
  }
`
const ListItem = styled(Link)`
  font-family: "Poppins";
  font-size: "0.875rem";
  font-weight: 500;
  color: ${theme.color.dark};
  padding: 10px 25px;
  white-space: nowrap;
  text-decoration: none;
  text-transform: uppercase;
  transition: color 120ms ease-in-out;
  &:hover {
    color: ${theme.color.primary};
  }
`
